<template>
  <page hide-breadcrumbs>
    <pf-page-section>
      <wizard :searched-domain="domainName" :available-domain="domainAvailable" />
    </pf-page-section>
  </page>
</template>

<script lang="ts" setup>
import { computed } from 'vue';
import Wizard from '../../components/wizard/wizard.vue';
import { pop } from '@common/utils';
import { useRoute } from 'vue-router';

const route = useRoute();

const domainAvailable = computed(() => route.query.domainAvailable === 'true' || route.query.domainAvailable === '1');
const domainName = computed(() => pop(route.query.domainName));
</script>
